export default "__VITE_PUBLIC_ASSET__d6f56b83__"